import { render } from "./DilemmaComponent.vue?vue&type=template&id=65e23cb9&scoped=true"
import script from "./DilemmaComponent.vue?vue&type=script&lang=js"
export * from "./DilemmaComponent.vue?vue&type=script&lang=js"

import "./DilemmaComponent.vue?vue&type=style&index=0&id=65e23cb9&scoped=true&lang=scss"

import exportComponent from "/builds/Partout/motus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e23cb9"]])

export default __exports__